import {
  Button,
  ContentLayout,
  FooterDots,
  Header,
  PageLayout,
  TextBanner,
} from 'components';
import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { ROUTE } from 'routers/data';
import style from './index.module.scss';
import { Form } from 'antd';
import { FormInstance } from 'antd/lib';
import { WORKER_STATUS } from 'api';
import { stepsData } from 'utilities/consts';
import { getStep } from 'utilities';
import { useProcessFooter } from 'hooks/useProcessFooter';
import { useSelector } from 'react-redux';

const CointainerFooter = ({
  form,
  step,
}: {
  form: FormInstance;
  step: number;
}) => {
  const { saveAndNext, isValid, userData, registrationLoading } =
    useProcessFooter({ step, form });

  return (
    <div className={style.footer}>
      <Button
        onClick={saveAndNext}
        loading={registrationLoading}
        disabled={
          !isValid ||
          (step === 3 &&
            [WORKER_STATUS.enabled, WORKER_STATUS.suspended].includes(
              userData.state,
            ))
        }
        className={style.button}
        buttonType="solid"
        shape="round"
      >
        {step === 3
          ? WORKER_STATUS.waitingRevision === userData.state
            ? 'VER ESTADO'
            : 'ENVIAR SOLICITUD'
          : 'CONTINUAR'}
      </Button>
      <FooterDots selected={step} />
    </div>
  );
};

export const Container = () => {
  const userStatus = useSelector(
    (state: any) => state.profile?.data?.state,
  ) as WORKER_STATUS;
  const [form] = Form.useForm();
  const { pathname } = useLocation();
  const step = getStep(pathname);

  return (
    (![WORKER_STATUS.suspended, WORKER_STATUS.enabled].includes(userStatus) && (
      <PageLayout>
        <Header
          allowBack={!pathname.match(ROUTE.complateProfileStep1)}
          title={step === 2 ? 'Valida tu dirección' : 'Complatar Perfil'}
        />
        <ContentLayout>
          <div className={style.formContent}>
            {!pathname.match(ROUTE.complateProfileStep3) && (
              <TextBanner
                title={stepsData[step]?.title}
                text={stepsData[step]?.text}
              />
            )}
            <Outlet context={form} />
            {pathname === ROUTE.complateProfileRoot && (
              <Navigate replace to={ROUTE.complateProfileStep1} />
            )}
          </div>
          <CointainerFooter form={form} step={step} />
        </ContentLayout>
      </PageLayout>
    )) || <Navigate to={ROUTE.profileStatus} />
  );
};
